// src/pages/HelloWorld.tsx
import React from "react";
import { Card, Typography } from "antd";

export const HelloWorld: React.FC = () => {
  return (
    <Card>
      <Typography.Title level={3}>Hello World</Typography.Title>
      <Typography.Paragraph>
        This is a standalone page rendered inside the same layout.
      </Typography.Paragraph>
    </Card>
  );
};
